import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Path } from 'react-native-svg'; // Import the necessary components


const DoesIconn = ({color}) => {
    return (
        <View>
            <Svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <Path d="M8.5 21.5H15.5" stroke={color} stroke-linecap="round" />
                <Path d="M12 21V17" stroke={color} stroke-linecap="round" />
                <Path d="M5.5 9C5.5 8.72386 5.72386 8.5 6 8.5H18C18.2761 8.5 18.5 8.72386 18.5 9V10C18.5 13.5899 15.5899 16.5 12 16.5C8.41015 16.5 5.5 13.5899 5.5 10V9Z" stroke={color} stroke-linecap="round" />
                <Path d="M11.5192 11.8626C11.4434 12.1282 11.5971 12.4049 11.8626 12.4808C12.1282 12.5566 12.4049 12.4029 12.4808 12.1374L11.5192 11.8626ZM13.7305 5.9432L14.2113 6.08056L13.7305 5.9432ZM14.9108 4.63569L14.7251 4.17145V4.17145L14.9108 4.63569ZM14.0845 5.07626L14.4556 5.41129L14.0845 5.07626ZM12.4808 12.1374L14.2113 6.08056L13.2498 5.80584L11.5192 11.8626L12.4808 12.1374ZM15.0965 5.09993L19.1857 3.46424L18.8143 2.53576L14.7251 4.17145L15.0965 5.09993ZM14.2113 6.08056C14.3571 5.57018 14.3961 5.4772 14.4556 5.41129L13.7133 4.74122C13.4619 5.01979 13.3686 5.38994 13.2498 5.80584L14.2113 6.08056ZM14.7251 4.17145C14.3235 4.33209 13.9648 4.46266 13.7133 4.74122L14.4556 5.41129C14.5151 5.34538 14.6036 5.29706 15.0965 5.09993L14.7251 4.17145Z" fill="#33363F" />
            </Svg>
        </View>
    )
}

export default DoesIconn